<template>
  <Modal
    v-show="showModal"
    :closable="true"
    :title="title"
    @close="showModal = false">
        <div class="modal--content">
          {{description}}
        </div>
  </Modal>
</template>

<script>

import Modal from '@/components/common/Modal.vue';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      showModal: false,
      title: '',
      description: '',
    };
  },
  methods: {
    show(serviceName, serviceDescription) {
      this.title = serviceName;
      this.description = serviceDescription;
      this.showModal = true;
    },
    handleClose() {
      if (this.showModal) {
        this.showModal = false;
      }
    },
    created() {
      this.$on('close', this.handleClose);
    },
  },
};
</script>
